import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
	selector: 'ngx-carousel-3d-slide',
	templateUrl: './ngx-carousel-3d-slide.component.html',
	styleUrls: ['./ngx-carousel-3d-slide.component.css']
})
export class NgxCarousel3dSlideComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
